<template>
  <SogFlexColumn>
    <HistoryListItemComponent
      v-for="(item) in _data"
      :key="item.id"
      style="  justify-content: left;"
      :data="item"
    />
  </SogFlexColumn>
</template>

<script setup lang="ts">

import History from "@/shared/model/History";
import HistoryListItemComponent from "@/modules/History/components/HistoryListItemComponent.vue";
import {ref, watch} from "vue";
import SogFlexColumn from "@/shared/ui/SogFlexColumn.vue";

interface Props {
  data?: History[]
}

const _data = ref<History[]>([])
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = withDefaults(defineProps<Props>(), {
    data: undefined
  }
)


/*
watch(props, () => {
  console.log(props.data)
  _data.value.length = 0;
  if (!props.data)
    return
  const ar = props.data ?? _data.value;
  ar.sort((a, b) => {
    return +new Date(b.date ?? 0) - +new Date(a.date ?? 0);
  }).map(t => _data.value.push(t))
}, {immediate: true})
*/

watch(
    () => props.data,
    (newVal) => {
      if (!newVal) {
        _data.value = []
        return
      }

      _data.value = [...newVal].sort((a, b) => {
        return +new Date(b.date ?? 0) - +new Date(a.date ?? 0)
      })
    },
    { immediate: true, deep: true }
)
</script>

<style scoped>
.sog-card {
  /*
  min-width: 100px;
  width: auto;
  */
  padding-top: 12px;
}

</style>
